import { observer } from 'mobx-react-lite'
import React, { useContext, useMemo, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { InfluencerContext } from '../../../../contexts/InfluencerContext'
import { SharedCampaignContext } from '../../../../contexts/Advertiser/SharedCampaignContext'
import { SharedInfluencerContext } from '../../../../contexts/Advertiser/SharedInfluencerContext'
import Authentication from '../../../../models/Authentication'
import Analytics from './OverviewParts/Analytics'
import BioDescription from './OverviewParts/BioDescription'
import Posts from './OverviewParts/Posts'
import SimilarCreators from './OverviewParts/SimilarCreators'
import TagManagement from './OverviewParts/TagManagement'
import Videos from './OverviewParts/Videos'
import axiosService from '../../../../utils/AxiosService'
import { toastError } from '../../../../components/FormComponents/Toasts'

export default observer(function Overview() {
  const params = useParams()
  const { id, authentication_id, campaign_authentication_id } = params
  const influencerContext = useContext(InfluencerContext)
  const sharedCampaignContext = useContext(SharedCampaignContext)
  const sharedInfluencerContext = useContext(SharedInfluencerContext)
  const [authentications, setAuthentications] = useState([])

  const isAdvertiserContext = !!sharedCampaignContext?.campaignState
  const isInfluencerShareContext = !!sharedInfluencerContext?.influencerState
  const currentId = isInfluencerShareContext
    ? (sharedInfluencerContext?.authentications?.[0]?.id)
    : (isAdvertiserContext ? authentication_id : id)

  useEffect(() => {
    if (isAdvertiserContext && authentication_id) {
      axiosService.get(`/api/advertiser/campaign_share/authentications/${authentication_id}/authentications`)
        .then(authentications => {
          const mappedAuthentications = authentications.map(authentication => new Authentication(authentication))
          setAuthentications(mappedAuthentications)
        })
        .catch((error) => {
          const errorMessage = error?.response?.data?.error || error?.data?.error || error?.error || error?.message || 'An error occurred'
          toastError(errorMessage)
        })
    }
  }, [isAdvertiserContext, authentication_id])

  const pmAuthentications = influencerContext?.authentications || []
  const sharedInfluencerAuthentications = sharedInfluencerContext?.authentications || []
  const currentAuthentications = isInfluencerShareContext
    ? sharedInfluencerAuthentications
    : (isAdvertiserContext ? authentications : pmAuthentications)

  const currentAuthentication = useMemo(() => currentAuthentications.find(authentication => +authentication.id === +currentId ) || new Authentication(), [currentId, currentAuthentications, currentAuthentications.length] )

  return (
    <div className="grid grid-cols-1 gap-4 bg-rb-grey dark:bg-rb-dark-mode-background">
      <BioDescription />
      {!isAdvertiserContext && !isInfluencerShareContext && <TagManagement />}
      <Analytics />
      {currentAuthentication.provider === 'instagram' && <Posts />}
      <Videos />
      {!isInfluencerShareContext && <SimilarCreators />}
    </div>
  )
})